import React from 'react';
import PropTypes from 'prop-types';
//ui components
import Fab from '@material-ui/core/Fab';

//utils
import makeStyles from '@material-ui/core/styles/makeStyles';

//assets
import Add from '@material-ui/icons/Add';

const useStyles = makeStyles((theme) => ({
    fab: ({ top, bottom, right, left, position }) => ({
        position,
        right,
        left,
        top,
        bottom,
        background: '#509ffa',
        color: 'white',
        fontSize: '1.8em',
        boxShadow: 'unset',
        '& svg': {
            width: '20px',
            height: '20px'
        },
        '&:hover': {
            background: theme.palette.primary.main
        },
        '&:disabled': {
            background: '#509ffa',
            color: 'white',
            cursor: 'not-allowed',
            pointerEvents: 'all !important',
            opacity: '0.5'
        },
        '&[disabled]:hover': {
            background: '#509ffa',
            color: 'white'
        }
    })
}));

/**
 * @typedef {import('@material-ui/core/Fab').FabProps & {top: number | string}} FabProps
 * @param {FabProps} props
 */
export default function AddFab({ top, bottom, position = 'absolute', right, left, ...props }) {
    const classes = useStyles({ top, bottom, position, right, left });

    return (
        <Fab className={classes.fab} size={'small'} {...props}>
            <Add color="inherit" />
            {/* <img src={addFab}/> */}
        </Fab>
    );
}

AddFab.propTypes = {
    top: PropTypes.any,
    bottom: PropTypes.any,
    right: PropTypes.any,
    left: PropTypes.any,
    position: PropTypes.string
};
